<panel></panel>
<div class="dashboard__content">
    <router-outlet></router-outlet>
</div>
